/* eslint no-console: 0 */
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "../fawter/App.vue";
import router from "../fawter/router";
import store from "../fawter/store";
import "../shared/filters";
import "../shared/directives";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import Notifications from "vue-notification";
import titleMixin from "@shared/Mixins/TitleMixin";
import "vue-search-select/dist/VueSearchSelect.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import VueCurrencyInput from "vue-currency-input";
import VueGtm from "vue-gtm";
import _ from "lodash";
import { initializeVuei18n } from "@locales/i18n_setup";
import Appsignal from "@appsignal/javascript";
import { errorHandler } from "@appsignal/vue";
// Global component registration
import HiddenInput from "../shared/components/UI/HiddenInput.vue";
import Page from "../dashboard/components/Page.vue";

const i18n = initializeVuei18n(Vue);

Object.defineProperty(Vue.prototype, "$_", { value: _ });

Vue.mixin(titleMixin);

Vue.component("HiddenInput", HiddenInput);
Vue.component("Page", Page);

Vue.use(VuejsDialog, {
  customClass: "unsaved-changes"
});

Vue.use(Notifications);
Vue.use(VueCurrencyInput);

Vue.config.productionTip = false;

Vue.use(VueGtm, {
  id: Dashboard.currentTenant.googleSettings.gtmId,
  vueRouter: router,
  enabled: false
});

const appsignal = new Appsignal({
  key: Dashboard.currentTenant.appsignalKey
});

Vue.config.errorHandler = errorHandler(appsignal, Vue);

const utcFix = function (option, dayjsClass) {
  dayjsClass.prototype.valueOf = function () {
    const addedOffset = !this.$utils().u(this.$offset)
      ? this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset())
      : 0;
    return this.$d.valueOf() - addedOffset * 60 * 1000;
  };
};

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(utcFix);
Object.defineProperty(Vue.prototype, "$dayjs", { value: dayjs });

const isDOMReady = ['complete', 'interactive'].includes(document.readyState);

function mountVueApp() {
  const app = new Vue({
    el: "#app",
    router,
    i18n,
    store,
    render: h => h(App)
  });

  if (Cookies.get("accept_gtm")) {
    app.$gtm.enable(!!Dashboard.currentTenant.googleSettings.gtmId);
  }
}

if (isDOMReady) {
  mountVueApp();
} else {
  document.addEventListener('DOMContentLoaded', mountVueApp);
}
